export default "./images/WN40.jpg";